<template>
	<div class="container">
		<div class="content">
			<div class="d_flex">
				<div class="assets_list_area w40 mr_10">
					<div class="card type1 mb_0">
						<h3 class="title mb_20">
							{{ $t('rtr_wallet_account-assets.title1') }}
						</h3>
						<div v-if="0" class="search_area">
							<input type="text" v-model="searchKeyword" />
							<a class="search_icon SEARCH"></a>
						</div>

						<div class="">
							<ul v-if="0" class="tab_area">
								<li :class="{ selected: selectedTab === 1 }">
									<a class="tab_item" @click="tabSelect(1)"
										><span>{{ $t('rtr_wallet_account-assets.tab1') }}</span></a
									>
								</li>
								<li :class="{ selected: selectedTab === 2 }">
									<a class="tab_item" @click="tabSelect(2)"
										><span>{{ $t('rtr_wallet_account-assets.tab2') }}</span></a
									>
								</li>
							</ul>

							<perfect-scrollbar
								class="asset_list_wrap"
								:options="{ wheelPropagation: false }"
							>
								<!--                자산 탭 표시-->
								<div v-if="selectedTab === 1">
									<ul class="asset_area">
										<li v-for="item in allAssets" :key="item.seq">
											<input
												:id="item.code"
												type="radio"
												class="assets_list_item"
												name="assets"
												:value="item.seq"
												v-model="selectedAssetSeq"
											/>
											<label class="asset_box asset_list_box" :for="item.code">
												<span :class="['icon ' + item.code, 'medium']"></span>
												<div>
													<p class="code mb_4">{{ item.code }}</p>
													<p class="name">{{ item.title }}</p>
												</div>
											</label>
											<span
												v-if="0"
												:class="[{ bookmarked: item.bookmark === 'Y' }, 'STAR']"
												@click="favoriteAssetHandler(item.seq)"
											></span>
										</li>
									</ul>
								</div>
								<!--                즐겨찾기 탭-->
								<div v-if="selectedTab === 2">
									<ul class="asset_area">
										<template v-for="item in allAssets" :key="item.seq">
											<li v-if="item.bookmark === 'Y'">
												<input
													:id="item.code"
													type="radio"
													class="assets_list_item"
													name="assets"
													:value="item.seq"
													v-model="selectedAssetSeq"
												/>
												<label
													class="asset_box asset_list_box"
													:for="item.code"
												>
													<span :class="['icon ' + item.code, 'medium']"></span>
													<div>
														<p class="code mb_4">{{ item.code }}</p>
														<p class="name">{{ item.title }}</p>
													</div>
												</label>
												<span
													:class="[
														{ bookmarked: item.bookmark === 'Y' },
														'STAR',
													]"
													@click="favoriteAssetHandler(item.seq)"
												></span>
											</li>
										</template>
									</ul>
								</div>
							</perfect-scrollbar>
						</div>
					</div>
				</div>
				<div class="assets_detail_area w60">
					<div v-if="!isRegistMode" class="card type1 mb_0">
						<h3 class="title mb_20">
							{{ $t('rtr_wallet_account-assets.title2') }}
						</h3>
						<div class="assets_detail_wrap">
							<div v-if="selectedAsset">
								<div v-if="selectedAccount">
									<div class="bg_black_box">
										<div class="asset_box mb_20">
											<span
												:class="[selectedAccount.asset_code, 'medium']"
											></span>
											<div>
												<p class="code mb_4">
													{{ selectedAccount.asset_code }}
												</p>
												<p class="name">
													{{ selectedAccount.asset_title }}
												</p>
											</div>
										</div>
										<div class="balance_area">
											<div class="quantity">
												{{ selectedAccount.balance }}
											</div>
											<span class="currency">
												{{ selectedAccount.asset_code }}
											</span>
										</div>
										<template v-if="0 && selectedAccount.asset_code === 'USDT'">
											<div class="button_area justify_between">
												<button class="button_blue" @click="notYet">
													{{ $t('account-wallet.btn_charge') }}
												</button>
												<div>
													<button
														class="button_white mr_5"
														@click="toSend(selectedAccount.seq)"
													>
														{{ $t('button.send') }}
													</button>
													<button
														class="button_bg_red"
														@click="toDeposit(selectedAccount.seq)"
													>
														{{ $t('button.request') }}
													</button>
												</div>
											</div>
										</template>

										<template v-else>
											<div class="button_area">
												<button
													class="button_white mr_5"
													@click="toSend(selectedAccount.seq)"
												>
													{{ $t('button.send') }}
												</button>
												<button
													class="button_bg_red"
													@click="toDeposit(selectedAccount.seq)"
												>
													{{ $t('button.request') }}
												</button>
											</div>
										</template>
									</div>

									<!--									<template v-if="selectedAccount.asset_code === 'USDT'">-->
									<!--										<span class="divide_line"></span>-->
									<!--										<p style="text-align: center; margin-top: 126px">-->
									<!--											{{ $t('account-wallet.text1') }}-->
									<!--										</p>-->
									<!--									</template>-->

									<!--									<template v-else>-->
									<!-- <template
										v-if="
											selectedAccount.asset_code !== 'USDT' &&
											selectedAccount.address
										"
									> -->
									<div class="qr_area">
										<p
											v-if="0 && selectedAccount.asset_code === 'USDT'"
											class="if_USDT mb_10"
										>
											{{ $t('rtr_wallet_account-assets.account') }}
										</p>
										<ul v-else class="tab_area">
											<li
												:class="[{ selected: qrTab === 'account' }, 'tab_item']"
												@click="qrTab = 'account'"
											>
												<a>{{ $t('rtr_wallet_account-assets.account') }}</a>
											</li>
											<li
												v-if="selectedAccount.address"
												:class="[{ selected: qrTab === 'address' }, 'tab_item']"
												@click="qrTab = 'address'"
											>
												<a>{{ $t('rtr_wallet_account-assets.address') }}</a>
											</li>
										</ul>
										<swiper
											:slidesPerView="1"
											:navigation="true"
											:modules="modules"
											@swiper="onSwiper"
											@slideChange="onSwiperChange"
										>
											<swiper-slide>
												<div class="qr_image_wrap">
													<Qrcode
														id="accountQr"
														:color="{
															dark: '#000000ff',
															light: '#ffffffff',
														}"
														type="image/png"
														:quality="1"
														:margin="1"
														:value="selectedAccount.account_number"
													/>
												</div>
												<div class="qr_download mb_20">
													<a @click="qrDownload('accountQr')"
														><img
															src="@/assets/images/icon/download.png"
															alt="qr download icon"
														/>
														download</a
													>
												</div>
												<p class="address mb_15" @click="copyAccount">
													{{ selectedAccount.account_number }}
												</p>
												<button
													class="button_copy"
													@click="copyClipboard('account_number')"
												>
													{{ $t('account-wallet.btn_copy') }}
												</button>
											</swiper-slide>
											<swiper-slide v-if="selectedAccount.address">
												<div class="qr_image_wrap">
													<Qrcode
														id="addressQr"
														:color="{
															dark: '#000000ff',
															light: '#ffffffff',
														}"
														type="image/png"
														:quality="1"
														:margin="1"
														:value="selectedAccount.address"
													/>
												</div>
												<div class="qr_download mb_20">
													<a @click="qrDownload('addressQr')"
														><img
															src="@/assets/images/icon/download.png"
															alt=""
														/>
														download</a
													>
												</div>
												<p class="address mb_15">
													{{ selectedAccount.address }}
												</p>
												<button
													class="button_copy"
													@click="copyClipboard('address')"
												>
													{{ $t('account-wallet.btn_copy') }}
												</button>
											</swiper-slide>
										</swiper>
									</div>
									<!--									</template>-->
								</div>
								<!--                자산 없을때-->
								<div v-else>
									<a class="box_dashed" @click="toAccountRegist">
										<span class="icon ADD"></span>
										<p>{{ $t('rtr_wallet_account-assets.text2') }}</p>
									</a>
								</div>
							</div>
							<div v-else>
								<div class="empty_set">
									<span class="select_account"></span>
									<p>{{ $t('rtr_wallet_account-assets.empty') }}</p>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="card type1 mb_0">
						<h3 class="title mb_20">
							{{ $t('rtr_wallet_account-assets.title3') }}
						</h3>
						<account-register
							:asset-info="selectedAsset"
							@closeRegist="this.isRegistMode = false"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon error"></div>
		<p class="status_text">{{ $t('rtr_wallet_account-assets.text1') }}</p>
		<div class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import AccountRegister from '@/components/AccountRegister';
import { Navigation } from 'swiper';
import { mapGetters } from 'vuex';
import ModalMessage from '@/components/Layout/ModalMessage';
import useClipboard from 'vue-clipboard3';
export default {
	name: 'AssetsList',
	components: { AccountRegister, ModalMessage },
	data() {
		return {
			selectedTab: 1,
			qrTab: 'account',
			favoriteAssetKey:
				'favoriteAsset_' + this.$store.state.auth.member_info.seq,
			favoriteAssetsSeq: [],
			selectedAssetSeq: null,
			isRegistMode: false,
			messageModal: false,
			searchKeyword: '',
			modules: [Navigation],
			swiper: null,
			// qrData: [
			// 	{ account_number: this.selectedAccount.account_number },
			// 	{ asset_code: this.selectedAccount.asset_code },
			// 	{ address: this.selectedAccount.address },
			// ],
		};
	},
	watch: {
		selectedAssetSeq() {
			this.isRegistMode = false;
			this.qrTab = 'account';
		},
		qrTab(value) {
			const index = value === 'account' ? 0 : 1;
			if (value) this.swiper.slideTo(index);
		},
	},
	computed: {
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		allAssets() {
			const list = [];
			const result = [];
			this.assets.forEach(item => {
				if (item.code === 'USDT') {
					list.unshift(item);
				} else {
					list.push(item);
				}
			});
			list.forEach((item, idx) => {
				const index = this.favoriteAssetsSeq.indexOf(item.seq);
				if (index !== -1) list[idx] = { bookmark: 'Y', ...item };
				else list[idx] = { bookmark: 'N', ...item };
			});

			result.push(list[0]);

			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'Y') result.push(item);
			});
			list.forEach(item => {
				if (item.code === 'USDT') return;
				if (item.bookmark === 'N') result.push(item);
			});

			if (this.searchKeyword) {
				return list.filter(item => {
					return (
						item.code
							.toLowerCase()
							.includes(this.searchKeyword.toLowerCase()) ||
						item.title.toLowerCase().includes(this.searchKeyword.toLowerCase())
					);
				});
			} else {
				return result;
			}
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === parseInt(this.selectedAssetSeq);
			});
		},
		selectedAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === parseInt(this.selectedAssetSeq);
			});
		},
	},
	mounted() {
		if (localStorage.getItem(this.favoriteAssetKey)) {
			this.favoriteAssetsSeq = JSON.parse(
				localStorage.getItem(this.favoriteAssetKey),
			);
		}
	},
	methods: {
		onSwiper(swiper) {
			this.swiper = swiper;
		},
		onSwiperChange(e) {
			this.qrTab = e.activeIndex === 0 ? 'account' : 'address';
		},
		tabSelect(e) {
			this.selectedTab = e;
		},
		favoriteAssetHandler(assetSeq) {
			const index = this.favoriteAssetsSeq.indexOf(assetSeq);
			if (index === -1) {
				// if (this.favoriteAssetsSeq.length === 5) {
				// 	this.messageModal = true;
				// 	return false;
				// }
				this.favoriteAssetsSeq.push(assetSeq);
			} else {
				this.favoriteAssetsSeq.splice(index, 1);
			}
			localStorage.setItem(
				this.favoriteAssetKey,
				JSON.stringify(this.favoriteAssetsSeq),
			);
		},
		toAccountRegist() {
			this.isRegistMode = true;
		},
		toSend(seq) {
			this.$router.push({
				name: 'pay-payment',
				query: { accountSeq: seq },
			});
		},
		toDeposit(seq) {
			this.$router.push({
				name: 'pay-deposit',
				query: { accountSeq: seq },
			});
		},
		qrDownload(id) {
			const dataUrl = document.getElementById(id).src;
			const link = document.createElement('a');
			link.href = dataUrl;
			link.download = 'qrcode';
			link.click();
		},
		copyClipboard(key) {
			try {
				useClipboard().toClipboard(this.selectedAccount[key]);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		copyAddress() {
			try {
				useClipboard().toClipboard(this.selectedAccount.address);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		copyAccount() {
			try {
				useClipboard().toClipboard(this.selectedAccount.account_number);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
	created() {
		if (this.$route.query.assetSeq) {
			this.selectedAssetSeq = this.$route.query.assetSeq;
		}
	},
};
</script>
